import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';

export const QuadrantGridStyles = css`
  ${MainStyles}
  :host {
    display: flex;
    flex-direction: column;
  }

  .footer {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    height: 56px;
    padding-right: 16px;
  }
`;
